export default __webpack_public_path__ + "static/media/IronTowerMap.baddb661.jpg";